import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const InfiniteScroll = ({
  children, loadMore, loading, initialLoad = false, page = null, initialPage = 0, loader = null,
  hasMore, className = '', threshold = 250, scrollElementRef = null, paginationParams = {}, dateLabelScrollHandler = () => {}
}) => {
  useEffect(() => {
    if (initialLoad) {
      loadMore(initialPage);
    }
  }, []);

  const handleScroll = () => {
    if (scrollElementRef?.current) {
      const { scrollHeight, scrollTop, clientHeight } = scrollElementRef.current;
      if (dateLabelScrollHandler) dateLabelScrollHandler();
      if (clientHeight - scrollHeight >= Math.floor(scrollTop - 1) && hasMore && !loading) {
        loadMore();
      }
      return;
    }
    const { innerHeight, scrollY } = window;
    const contentHeight = document.getElementById('scroller')?.clientHeight;
    if (contentHeight !== null && innerHeight + scrollY > contentHeight - threshold && hasMore && !loading) {
      loadMore(page);
    }
  };

  useEffect(() => {
    (((scrollElementRef || {}).current) || window).addEventListener('scroll', handleScroll);
    return () => {
      ((scrollElementRef || {}).current || window).removeEventListener('scroll', handleScroll);
    };
  }, [paginationParams, page, hasMore]);

  return (
    <div id="scroller" className={ className }>
      { children }
      { loading ? loader : null }
    </div>
  );
};

const mapStateToProps = ({ advisorOrders }) => ({
  paginationParams: (advisorOrders || {}).paginationParams
});

export default connect(mapStateToProps, {})(InfiniteScroll);
